


















































import { Component, Prop, Vue } from 'vue-property-decorator'

import Version from '@/models/version'

@Component
export default class NoteVersionCardContent extends Vue {
  @Prop() version!: Version
  @Prop() usersHash!: { [key: string]: string }
  @Prop() fieldValueMethod!: Function
  @Prop() fieldValueAfterMethod!: Function
  @Prop() fieldValueChangedMethod!: Function
}
